import React from "react";
import PropTypes from "prop-types";

import { Assigner, ClientMenu } from "./components";

function WithMenu(TileComponent) {
  const withMenu = ({
    data,
    onAssign,
    onTopTaskComplete,
    onDelete,
    onMoveUp,
    onArchive,
    context,
    ...props
  }) => {
    const { id, tasksStats } = data;
    const { fetchAssignees } = context;

    return (
      <TileComponent
        context={context}
        data={data}
        menuSlot={
          <ClientMenu
            onClickCompleteTopTask={
              tasksStats?.filteredTasks?.length > 0
                ? () => {
                    return onTopTaskComplete(tasksStats.filteredTasks[0]);
                  }
                : undefined
            }
            onClickDelete={() => {
              return onDelete(id);
            }}
            onClickMoveTop={() => {
              return onMoveUp(id);
            }}
            onClickArchive={() => {
              return onArchive(id);
            }}
          />
        }
        bottomRightSlot={
          <Assigner
            data={data}
            fetchAssignees={fetchAssignees}
            onAssign={onAssign}
          />
        }
        {...props}
      />
    );
  };

  withMenu.propTypes = {
    context: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onAssign: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onTopTaskComplete: PropTypes.func.isRequired,
    onMoveUp: PropTypes.func.isRequired,
    onArchive: PropTypes.func.isRequired,
  };

  withMenu.defaultProps = {};

  return withMenu;
}

export default WithMenu;
